import { Link } from "react-router-dom";
import Header from "@/sections/Header";
import Footer from "@/sections/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-32 pb-24" data-testid="not-found-page">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#ff3333] mb-3">// 404</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter mb-4">
            That page rugged.
          </h1>
          <p className="text-[#e2e2e2] mb-8">Nothing lives at <span className="font-mono text-[#cfff04]">{window.location.pathname}</span>.</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/explore" data-testid="nf-explore" className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-sm px-6 py-3">Explore coins</Link>
            <Link to="/create" data-testid="nf-create" className="border border-[#3a3a3a] hover:border-[#cfff04] px-6 py-3 font-mono text-xs uppercase tracking-widest">Launch one</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
